export default __webpack_public_path__ + "static/logo-white-b1ee1a3a96c4d24c976a535d05b38d72.png";